import { Action } from "@ngrx/store";
import { ReduxAction } from "./redux.action";
import { UtilService } from "../services";
import { Patient } from "../models";

export class SetPatientAction implements ReduxAction {
  type: string = "SET_FULL_PATIENT";
  patient: Patient;
  constructor(patient: Patient, private utilService: UtilService) {
    this.patient = patient;
    this._setPatientDob();
    this._setPatientBillTo();
    this._setPatientMobileNumber();
    this._setPatientIncomplete();
    this.patient.Gender = patient.Gender || null;
    this.patient.MiddleName = patient.MiddleName || null;
    this.patient.Suffix = patient.Suffix || null;
  }

  get() {
    return this.patient;
  }

  private _setPatientIncomplete() {
    if(this.patient.InsurancePolicies[0]) {
      this.patient.Incomplete = !(
        this.patient.FirstName &&
        this.patient.LastName &&
        this.patient.Gender &&
        this.patient.Address &&
        this.patient.PhoneNumbers &&
        this.patient.InsurancePolicies[0].BillTo &&
        this.patient.Provider &&
        this.patient.PlanNumber
      );
    }
  }

  private _setPatientDob() {
    if (
      this.patient.BirthYear &&
      this.patient.BirthMonth &&
      this.patient.BirthDay
    ) {
      this.patient.Dob = this.utilService.formatDate(
        this.patient.BirthYear,
        this.patient.BirthMonth,
        this.patient.BirthDay
      );
    }
    let dob = this.patient.Dob || "";
    let ar = dob.split("-");
    this.patient.BirthYear = ar[0] || null;
    this.patient.BirthMonth = ar[1] || null;
    this.patient.BirthDay = Number(ar[2]) || null;
  }

  private _setPatientBillTo() {
    if(this.patient.InsurancePolicies[0]) {
      if (this.patient.InsurancePolicies[0].BillTo == 'Commercial' || this.patient.InsurancePolicies[0].BillTo == "Medicare-Part B" || this.patient.InsurancePolicies[0].BillTo == "Patient") {
        this.patient.BillToText = '';
      } else {
        this.patient.BillToText = this.patient.InsurancePolicies[0].BillTo;
      }
    }
  }

  private _setPatientMobileNumber() {
    if (this.patient.PhoneNumbers) {
      this.patient.PhoneNumbers.Mobile = this.patient.PhoneNumbers.Mobile || "";
      this.patient.PhoneNumbers.Mobile = this.patient.PhoneNumbers.Mobile.replace(
        /[^0-9]/g,
        ""
      );
      if (this.patient.PhoneNumbers.Mobile.length === 10) {
        this.patient.PhoneNumbers.Mobile = [
          this.patient.PhoneNumbers.Mobile.substr(0, 3),
          this.patient.PhoneNumbers.Mobile.substr(3, 3),
          this.patient.PhoneNumbers.Mobile.substr(6)
        ].join("-");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/actions/patient.actions.ts